export default "__VITE_ASSET__5ef3d49d__"